export const admin = {
    name: "admin",
    headingTextColor: "hsl(200, 100%, 13%)",
    headingFontWeight: 300,
    labelFontWeight: 500,
    primary: "hsl(200, 100%, 13%)",
    secondary: "hsl(200, 60%, 79%)",
    secondaryContrast: "hsl(200, 80%, 22%)",
    tertiary: "hsl(200, 55%, 30%)",
    tertiaryContrast: "#fff",
    success: "hsl(95, 64%, 40%)",
    successContrast: "#fff",
    warning: "hsl(37, 90%, 45%)",
    warningContrast: "#fff",
    danger: "hsl(20, 90%, 38%)",
    dark: "#222428",
    medium: "hsl(222, 12%, 84%)",
    mediumContrast: "#222428",
    light: "#f0f1f3",
    lightContrast: "#2f3237",
    buttonPadding: "8px 12px",
    smallButtonPadding: "4px 6px",
    largeButtonPadding: "12px 18px",
    buttonStyle: "outset",
    buttonRadius: 4,
    largeButtonRadius: 6,
    buttonBorderWidth: 2,
    checkboxBorderWidth: 1,
};
export const adminDark = {
    ...admin,
    name: "admin-dark",
    headingTextColor: "#c1e0f0",
    invert: true,
    primary: "hsl(200, 80%, 30%)",
    primaryContrast: "#fff",
    secondary: "hsl(200, 60%, 18%)",
    secondaryContrast: "#fff",
    tertiary: "hsl(200, 100%, 13%)",
    success: "hsl(95, 64%, 35%)",
    warning: "hsl(37, 90%, 40%)",
    danger: "hsl(20, 90%, 33%)",
    dark: "#f4f5f8",
    darkContrast: "#2f3237",
    medium: "hsl(200, 20%, 20%)",
    mediumContrast: "#f4f5f8",
    light: "#222428",
    lightContrast: "#f4f5f8",
    linkTextColor: "#bde",
};
